import { LoaderFunction, useLoaderData } from "react-router-dom";
import { DecimalResult } from "../../../common/api/decimal/utils.ts";
import { getFavorites } from "../../../common/api/decimal/methods/favorites.ts";
import { getAssetsByVbid } from "../../../common/api/bridge/methods.ts";
import { ExploreAugmentedAsset } from "../../../common/api/decimal/common-types/manageAssets.ts";

const getFavoritesData = async (): Promise<
  DecimalResult<ExploreAugmentedAsset[]>
> => {
  const favoritesResult = await getFavorites();
  if (!favoritesResult.ok) {
    throw new Error("Could not load favorites");
  }
  const vbids = favoritesResult.ok
    ? favoritesResult.data?.map((fave) => fave.manageAsset.vbid)
    : [];
  if (vbids?.length) {
    const bridgeResult = await getAssetsByVbid(vbids);
    const exploreLookup = bridgeResult.content.reduce<
      Record<string, VST.Bridge.Asset>
    >((acc, curr) => {
      acc[curr.vbid] = curr;
      return acc;
    }, {});
    const res = favoritesResult as DecimalResult<ExploreAugmentedAsset[]>;
    if (res.data) {
      for (const asset of res.data) {
        asset.explore = exploreLookup[asset.manageAsset.vbid];
      }
    }
    return res;
  }
  return favoritesResult as DecimalResult<ExploreAugmentedAsset[]>;
};

export const favoritesLoader: LoaderFunction = () => {
  const favorites = getFavoritesData();
  return { favorites };
};

export function useFavoritesLoader() {
  return useLoaderData<{
    favorites: ReturnType<typeof getFavoritesData>;
  }>();
}
